import { useBed } from '@hook'
import { DeleteModal } from '@ui'
import { getError, showToast } from '@util'
import { useState } from 'react'

type Props = {
  onClose: () => void
  id?: string
}

export const RemoveBed = ({ onClose, id }: Props) => {
  const [isLoading, setIsLoading] = useState(false)
  const { deleteBed } = useBed({})
  const handleClose = () => {
    onClose()
    setIsLoading(false)
  }
  const deleteHandler = async () => {
    setIsLoading(true)
    try {
      await deleteBed(id as string)
      showToast('Bed deleted successfully')
      handleClose()
    } catch (error) {
      getError(error)
    }
    setIsLoading(false)
  }
  return (
    <DeleteModal
      description="Confirm that you want to delete this bed"
      handleSubmit={deleteHandler}
      isLoading={isLoading}
      onClose={handleClose}
      title="Delete Bed"
    />
  )
}
